import { useEffect, useState } from 'react';

interface LendoIconProps {
  name: string;
  size: string;
  className?: string;
}

const iconMap: { [key: string]: () => Promise<{ default: string }> } = {
    'icon/phone-icon': () => import('../assets/phone-icon.svg'),
    'icon/mail': () => import('../assets/mail.svg'),
    'logo': () => import('../assets/logo.svg'),
    'icon/facebook': () => import('../assets/facebook.svg'),
    'icon/instagram': () => import('../assets/instagram.svg'),
    'icon/youtube': () => import('../assets/youtube.svg'),
    'icon/login': () => import('../assets/arrow-right-to-bracket-light.svg'),
    'icon/angle-down': () => import('../assets/angle-down.svg'),
    'icon/coin-and-hand': () => import('../assets/coin-and-hand.svg'),
    'purpose/refinansiering': () => import('../assets/refinansiering.svg'),
    'purpose/bil': () => import('../assets/bil.svg'),
    'purpose/kredittkort': () => import('../assets/kredittkort.svg'),
    'purpose/bolig': () => import('../assets/bolig.svg'),
    'purpose/regninger': () => import('../assets/regninger.svg'),
    'icon/arrow-right-to-bracket-light': () => import('../assets/arrow-right-to-bracket-light.svg'),
    'purpose/helse': () => import('../assets/helse.svg'),
    'icon/score': () => import('../assets/score.svg'),
    'icon/piechart': () => import('../assets/piechart.svg'),
    'icon/barchart': () => import('../assets/barchart.svg'),
    'icon/menu': () => import('../assets/menu.svg'),
    'icon/close-menu': () => import('../assets/close-menu.svg'),
    'icon/hmkjl': () => import('../assets/hmkjl.svg'),
    'icon/arrow-right-green': () => import('../assets/arrow-right-green.svg'),
};

export default function LendoIcon({ name, size, className }: LendoIconProps) {
  const [iconSrc, setIconSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    const importIcon = async () => {
      if (iconMap[name]) {
        try {
          const { default: src } = await iconMap[name]();
          setIconSrc(src);
        } catch (error) {
          console.error(`Could not load icon: ${name}`, error);
        }
      }
    };

    importIcon();
  }, [name]);

  const combinedClassName = ['lendo-icon', className].filter(Boolean).join(' ');

  if (!iconSrc) {
    return <div style={{ height: size, width: 'auto' }} className={combinedClassName}>[{name}]</div>;
  }

  return (
    <img
      src={iconSrc}
      alt={`${name} icon`}
      style={{ height: size, width: 'auto' }}
      className={combinedClassName}
    />
  );
}
